import {useAlertPopper} from "hooks/useAlertPopper";
import {Voyage} from "views/ProcessDetails/refactor/types/voyages.types";
import {AlertMessage} from "views/ProcessDetails/refactor/components/ProcessBoarding/components/VoyagesV2/components";

export type DeletionConfirmationConfig = {
  voyage: Voyage;
  index: number;
  onConfirm: () => void | Promise<void>;
};

export const useVoyageDeletionConfirmation = () => {
  const {isOpen, anchorEl, config, openAlert, closeAlert} = useAlertPopper();

  const openDeletionConfirmation = (
    event: React.MouseEvent<HTMLElement>,
    {voyage, onConfirm}: DeletionConfirmationConfig,
  ) => {
    openAlert(event.currentTarget, {
      title: "Você tem certeza que deseja deletar esta viagem?",
      message: (
        <AlertMessage
          originName={voyage.origin?.name}
          destinationName={voyage.destination?.name}
        />
      ),
      icon: "delete",
      color: "error",
      placement: "bottom",
      showCancelButton: true,
      confirmButtonText: "Apagar",
      onConfirm,
    });
  };

  return {
    isOpen,
    anchorEl,
    config,
    closeAlert,
    openDeletionConfirmation,
  };
};
